import { observer } from "mobx-react-lite";
import * as React from "react";
import { QuerySearch } from "src/components/QuerySearch/QuerySearch";

import { RtCtrlFiltration } from "../../ctrl";

type PropsRtSearch = {
  store: Pick<
    RtCtrlFiltration<{ text?: string }>,
    "changeSingleFilter" | "filters"
  >;
};

/** Строка поиска таблицы: связывает QuerySearch с фильтром `text` стора */
export const RtSearch: React.FC<PropsRtSearch> = observer(({ store }) => (
  <QuerySearch
    value={store.filters?.text}
    onChange={(v) => store.changeSingleFilter("text", v)}
  />
));
